import { useAdminGet } from '@reapitform/hooks'
import { FullFormModel } from '../types'

export const ADMIN_FULL_FORM_QUERY_KEY = ['admin-full-form']

/**
 * Loads the complete definition graph for a form version (`GET /api/forms/{formRef}/versions/{versionRef}/full`)
 * — form metadata, version + flags, and the nested review/recipient/PDF structure — used by the builder.
 */
export const useAdminFullForm = (formReferenceID?: string, versionReferenceID?: string) => {
  const [data, loading, errorString, refresh] = useAdminGet<FullFormModel>({
    path: `/api/forms/${formReferenceID}/versions/${versionReferenceID}/full`,
    retry: false,
    queryKeys: [...ADMIN_FULL_FORM_QUERY_KEY, formReferenceID ?? '', versionReferenceID ?? ''],
    fetchWhenTrue: [Boolean(formReferenceID), Boolean(versionReferenceID)],
  })

  return { data, loading, errorString, refresh }
}
